export class BaseInstruction {
  constructor() {
    /** allows to programmatically manipulate input map */
    this.dynamicInputMapAssignments = [];
    this.directiveLoaderPlugins = [];
    /** if fieldwrapper is enabled, isInput will be passed to fieldWrapper[noInput]. */
    this.isInput = true;
    this.useFieldWrapper = true;
  }
  setConfig(config) {
    this.config = {
      ...this.getDefaults(),
      ...config
    };
  }
  // override these to compose maps in child classes
  getInputMap() {
    return this.inputMap;
  }
  getAttributeMap() {
    return this.attributeMap;
  }
  getDefaults() {
    return {};
  }
  // TODO: Support for attributes like class
  applyDirectives(comp, injector, initialFormValue) {
    try {
      this.directiveLoaderPlugins.forEach(plugin => {
        plugin(comp, injector, this.config, initialFormValue);
      });
    } catch (err) {
      console.error(err);
    }
  }
  addDirectivesPlugin(plugin) {
    this.directiveLoaderPlugins.push(plugin);
  }
  // use inputMap + merged config to build the data map to be passed to the component.
  createComponentInputsMap(formGroup, formService) {
    const tmp = this.createDataMap(formGroup, formService || null, "inputMap");
    return tmp;
  }
  createComponentAttributesMap(formGroup, formService) {
    const tmp = this.createDataMap(formGroup, formService || null, "attributeMap");
    return tmp;
  }
  addDynamicInputValues(map, sourceMapName, formGroup, formService) {
    return map;
  }
  createDataMap(formGroup, formService, sourceMapName) {
    const sourceMapFactory = sourceMapName === 'attributeMap' ? this.getAttributeMap : this.getInputMap;
    const sourceMap = sourceMapFactory.call(this);
    if (Object.keys(sourceMap).length === 0) return {};
    const map = {};
    for (const propName in sourceMap) {
      if ({}.hasOwnProperty.call(sourceMap, propName)) {
        const valueDataSource = sourceMap[propName];
        /**
         * Note that all data added to map will be explicitly assigned to the created component.
         * Thus we must carefully check if a value was defined explicitly.
         * This is to prevent setting inputs to "undefined" by accident.
         */
        if (Object.hasOwnProperty.call(this.config, valueDataSource)) {
          map[propName] = this.config[valueDataSource];
        }
      }
    }
    if (sourceMapName === 'inputMap' && this.dynamicInputMapAssignments.length) {
      this.dynamicInputMapAssignments.forEach(handler => {
        handler(this.config, map);
      });
    }
    return this.addDynamicInputValues(map, sourceMapName, formGroup, formService);
  }
}